window.SMTX = window.SMTX || {};

window.log = function (args) {
  var enabled = true;

  if (enabled && console && console.log) {
    console.log(args);
  }

};



var $_globalAlerts = $('#global_alerts');
var _alertDismissedValue = 'alertDismissed';

$_globalAlerts.find('.callout').each(function () {
  var $me = $(this);

  if (getCookie($me.data('id')) === null) {
    $me.removeClass('hide');
  }
});

$(document).foundation();

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
}



